import { createSelector } from 'reselect'
import { get } from 'lodash'
import { bulkForm } from 'constants/layout/tasks/tasks-registration-award-leaders'
import { LEADERS_BULK, PROGRESS_STATES } from 'constants/enums'


const getRegistrations = state => get(state,
  'api.tasks.registrationAwardLeaders.list',
  [])

const getBulkType = state => get(state,
    `form.${bulkForm}.values.bulkType`,
    '')

const mapForBulk = (registrations, bulkType) => {
  switch (bulkType) {
    case PROGRESS_STATES.awardRegApproval.id:
      return registrations.filter(r =>
        get(r, 'awardLeaderRegistration.isEmailConfirmed'))
        .map(r => get(r, 'awardLeaderRegistration.id'))

    case LEADERS_BULK.assignLabels.id:
      return registrations.map(r => get(r, 'awardLeaderRegistration.id'))

    case LEADERS_BULK.unassignLabels.id:
      return registrations.map(r => get(r, 'awardLeaderRegistration.id'))

    default:
      return []
  }
}

export default createSelector([getRegistrations, getBulkType],
  mapForBulk)
